function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.128 0h29.744c1.783 0 2.43.186 3.082.534.652.349 1.163.86 1.512 1.512.348.652.534 1.299.534 3.082v13.744c0 1.783-.186 2.43-.534 3.082a3.635 3.635 0 0 1-1.512 1.512c-.652.348-1.299.534-3.082.534H5.128c-1.783 0-2.43-.186-3.082-.534a3.635 3.635 0 0 1-1.512-1.512C.186 21.302 0 20.655 0 18.872V5.128c0-1.783.186-2.43.534-3.082A3.635 3.635 0 0 1 2.046.534C2.698.186 3.345 0 5.128 0z",
  fill: "#FF6168"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 19H8a2.002 2.002 0 0 1-2-2V7a2.002 2.002 0 0 1 2-2h6v2H8v10h6v2zM24 19h-6a2.002 2.002 0 0 1-2-2V5h2v12h6v2zM32 5h-4a2.002 2.002 0 0 0-2 2v10a2.002 2.002 0 0 0 2 2h4a2.002 2.002 0 0 0 2-2V7a2.002 2.002 0 0 0-2-2zm-4 12V7h4v10h-4z"
})));
const SvgClo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 24,
  viewBox: "0 0 40 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clo.f543aa77.svg";
export { ForwardRef as ReactComponent };